module.exports = {"brand":{"url":"","alt":"Linuk","href":"/"},"navItemsStart":[],"navItemsEnd":[{"href":"#about","label":"about"},{"href":"#projects","label":"projects"}]}


//////////////////
// WEBPACK FOOTER
// ./src/contents/menu.json
// module id = 40
// module chunks = 0